const getUserId = async ({email}) => {
  try {
    const response = await fetch('/api/get-user-id', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email
      })
    });

    const data = await response.json();

    return data.data.id;
  } catch (error) {
    console.log(error);
  }
};

export default getUserId;
